import { zodResolver } from '@hookform/resolvers/zod';
import { Turnstile } from '@marsidev/react-turnstile';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { z } from 'zod';
import { requestPasswordReset } from '../auth/client.js';

const Schema = z.object({ email: z.string().email() });
type FormData = z.infer<typeof Schema>;

export function ForgotPassword() {
  const { t } = useTranslation('auth');
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormData>({
    resolver: zodResolver(Schema),
  });
  const [captcha, setCaptcha] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const onSubmit = handleSubmit(async (data) => {
    if (!captcha) return;
    try {
      await requestPasswordReset({
        email: data.email,
        redirectTo: `${window.location.origin}/reset-password`,
        fetchOptions: { headers: { 'cf-turnstile-response': captcha } },
      });
    } catch {
      // enumeration protection — always pretend success
    }
    setDone(true);
  });

  if (done) {
    return (
      <div className="mx-auto mt-16 max-w-md rounded border bg-white p-6">
        <p className="text-sm">
          Si la cuenta existe, te enviamos un enlace para restablecer tu contraseña.
        </p>
        <Link className="mt-4 inline-block text-sm text-blue-600" to="/login">
          {t('login')}
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto mt-16 max-w-sm rounded border bg-white p-6">
      <h1 className="mb-4 text-xl font-semibold">{t('forgotPassword')}</h1>
      <form onSubmit={onSubmit} className="space-y-3">
        <input
          type="email"
          {...register('email')}
          placeholder={t('email')}
          className="w-full rounded border px-3 py-2"
        />
        <Turnstile siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY ?? ''} onSuccess={setCaptcha} />
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full rounded bg-blue-600 py-2 text-white disabled:opacity-50"
        >
          {t('forgotPassword')}
        </button>
      </form>
    </div>
  );
}
